import { useEffect } from "react";

export const useResizeObserver = (ref, onChange) => {
	useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				if (entry.target === ref.current) {
					onChange(entry);
				}
			}
		});

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => {
			if (ref.current) {
				observer.unobserve(ref.current);
			}
		};
	}, [onChange, ref.current]);

	return {
		ref,
	};
};
